<template>
  <div class="common-loading" v-if="state.loading.length > 0">
    <div class="loading-spinner">
      <b-spinner label="読み込み中"></b-spinner>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CommonLoading',
  computed: {
    ...mapState({
      state: state => state.common,
    }),
  },
};
</script>

<style scoped>
.common-loading {
  display: table;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  opacity: 0.8;
  z-index: 65535;
}

.common-loading >>> .loading-spinner {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  width: 24px;
  height: 24px;
}
</style>
